/**
 * Shipper HQ
 *
 * @copyright Copyright (c) 2026 Zowta Ltd (http://www.shipperhq.com)
 * Copyright, 2026, Zowta, LLC - US license
 */

import React from 'react'
import styles from './MerchantResults.module.css'

const STATS = [
    { value: '100%', label: 'Higher conversions' },
    { value: '$200K', label: 'Saved' },
    { value: '33%', label: 'Sales recovered' },
    { value: '-50%', label: 'Cart abandonment' },
]

export const MerchantResults: React.FC = () => {
    return (
        <div className={styles.panel} data-testid="merchant-results-panel">
            <h3 className={styles.heading}>Real results from real merchants</h3>
            <div className={styles.statsGrid}>
                {STATS.map((stat) => (
                    <div key={stat.label} className={styles.statTile}>
                        <span className={styles.statValue}>{stat.value}</span>
                        <span className={styles.statLabel}>{stat.label}</span>
                    </div>
                ))}
            </div>
            <p className={styles.quote}>
                &ldquo;The day we plugged ShipperHQ into our website, it cut
                customer service tickets and cart abandonment in half.&rdquo;
            </p>
            <p className={styles.attribution}>
                Jason Nista, CEO, Clean Eatz Kitchen
            </p>
        </div>
    )
}
